import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemperatureThermometerHigh = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "temperature-thermometer-high" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M13.5,15.418V3.75a3,3,0,0,0-6,0V15.418a4.5,4.5,0,1,0,6,0Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 10.5,
			cy: 18.75,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 10.5,
			y1: 3.75,
			x2: 10.5,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 16.5,
			y1: 3.75,
			x2: 18,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 16.5,
			y1: 8.25,
			x2: 18,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 16.5,
			y1: 12.75,
			x2: 18,
			y2: 12.75
		})
	]
});
export default SvgTemperatureThermometerHigh;
